import React from 'react';
import '../styles/Video.css';
import schoolVideo from '../Assets/Videos/school.mp4';

function Video() {
  return (
    <section className="video-hero" id="video">
      <video className="video-bg" autoPlay muted loop playsInline>
        <source src={schoolVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="video-overlay">
        <div className="video-content">
          <a
            href={schoolVideo}
            target="_blank"
            rel="noopener noreferrer"
            className="watch-button"
          >
            <div className="circle-play">
              <div className="triangle-right"></div>
            </div>
            <span className="watch-text">WATCH OUR VIDEO</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Video;
